import { useState } from "react";

function App() {
  const [address, setAddress] = useState("");
  const [question, setQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);

  const askSolSpeak = async () => {
    if (!address || !question) return;
    setLoading(true);
    setResponse("");

    try {
      const rpcResponse = await fetch(
        "https://solana-mainnet.g.alchemy.com/v2/SUTrfpdWqOz-RNZ1tzQYX",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            jsonrpc: "2.0",
            id: 1,
            method: "getBalance",
            params: [address],
          }),
        }
      );
      const rpcData = await rpcResponse.json();
      const lamports = rpcData.result?.value ?? 0;
      const solBalance = (lamports / 1e9).toFixed(4);

      const aiResponse = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer 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",
        },
        body: JSON.stringify({
          model: "llama-3.3-70b-versatile",
          max_tokens: 1000,
          messages: [
            {
              role: "user",
              content: `You are SolSpeak, an AI assistant that helps users understand their Solana wallet. 
              Wallet address: ${address}
              Current SOL balance: ${solBalance} SOL
              User question: ${question}
              Answer in simple, friendly, non-technical language.`,
            },
          ],
        }),
      });

      const aiData = await aiResponse.json();
      setResponse(aiData.choices[0].message.content);
    } catch (err) {
      setResponse("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.badge}>SOLANA AI ASSISTANT</div>
        <h1 style={styles.title}>⚡ SolSpeak</h1>
        <p style={styles.subtitle}>Ask anything about any Solana wallet in plain English</p>

        <div style={styles.inputGroup}>
          <label style={styles.label}>WALLET ADDRESS</label>
          <input
            style={styles.input}
            placeholder="Enter any Solana wallet address..."
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>YOUR QUESTION</label>
          <input
            style={styles.input}
            placeholder='e.g. "What is my balance?" or "Is this wallet safe?"'
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
        </div>

        <button style={styles.button} onClick={askSolSpeak} disabled={loading}>
          {loading ? "⏳ Analyzing wallet..." : "⚡ Ask SolSpeak"}
        </button>

        {response && (
          <div style={styles.responseBox}>
            <div style={styles.responseHeader}>AI RESPONSE</div>
            <p style={styles.responseText}>{response}</p>
          </div>
        )}

        <div style={styles.footer}>
          Powered by Solana RPC • Groq AI • Built for Colosseum Frontier 2026
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#080808",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    fontFamily: "'Courier New', monospace",
  },
  card: {
    backgroundColor: "#111",
    border: "1px solid #222",
    borderRadius: "16px",
    padding: "48px 40px",
    width: "100%",
    maxWidth: "620px",
    boxShadow: "0 0 60px rgba(20, 241, 149, 0.05)",
  },
  badge: {
    display: "inline-block",
    backgroundColor: "rgba(20, 241, 149, 0.1)",
    color: "#14f195",
    border: "1px solid rgba(20, 241, 149, 0.3)",
    borderRadius: "20px",
    padding: "4px 14px",
    fontSize: "0.7rem",
    letterSpacing: "2px",
    marginBottom: "20px",
  },
  title: {
    color: "#fff",
    fontSize: "2.8rem",
    margin: "0 0 10px 0",
    fontWeight: "bold",
  },
  subtitle: {
    color: "#555",
    fontSize: "0.95rem",
    marginBottom: "36px",
    lineHeight: "1.6",
  },
  inputGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    color: "#444",
    fontSize: "0.7rem",
    letterSpacing: "2px",
    marginBottom: "8px",
  },
  input: {
    width: "100%",
    padding: "14px 16px",
    backgroundColor: "#0d0d0d",
    border: "1px solid #222",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "0.95rem",
    outline: "none",
    boxSizing: "border-box",
  },
  button: {
    width: "100%",
    padding: "16px",
    backgroundColor: "#14f195",
    color: "#000",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "8px",
    marginBottom: "24px",
    letterSpacing: "1px",
  },
  responseBox: {
    backgroundColor: "#0d0d0d",
    border: "1px solid rgba(20, 241, 149, 0.2)",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "24px",
  },
  responseHeader: {
    color: "#14f195",
    fontSize: "0.7rem",
    letterSpacing: "2px",
    marginBottom: "12px",
  },
  responseText: {
    color: "#ccc",
    lineHeight: "1.8",
    fontSize: "0.95rem",
    margin: 0,
  },
  footer: {
    color: "#333",
    fontSize: "0.7rem",
    textAlign: "center",
    letterSpacing: "1px",
  },
};

export default App;